export default __webpack_public_path__ + "static/img-perk-1-8a07e3cad7a9e5be08906b3539edb0a2.png";